import { ref, watch } from 'vue';

export const useSessionStorageRef = <T>(initValue: T, key: string) => {
  // 同步读取 sessionStorage，避免先渲染默认值再异步切换导致的竞态问题
  const stored = sessionStorage.getItem(key);
  const initialValue = stored ? JSON.parse(stored) : initValue;
  const value = ref(initialValue);
  watch(value, (newValue) => {
    sessionStorage.setItem(key, JSON.stringify(newValue));
  });
  return value;
};
